import Vue from 'vue'
import Router from 'vue-router'
import Page from './views/Page.vue'
import PageList from './views/PageList.vue'
import Updates from './views/Updates.vue'
import store from './store'

Vue.use(Router)


const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Page,
			props: { pageIdentifier: '__HOMEPAGE__', urlTitle: '' }
		},
		{
			path: '/wiki',
			redirect: '/'
		},
		{
			path: '/wiki/updates',
			redirect: '/updates'
		},
		{
			path: '/wiki/pages',
			name: 'page-list',
			component: PageList
		},
		{
			path: '/wiki/pages/:pageIdentifier/:urlTitle',
			name: 'page',
			component: Page,
			props: true
		},
		{
			path: '/updates',
			name: 'updates',
			component: Updates
		}
	]
})

router.afterEach((to, from) => {
	setTimeout(() => {
		window.vm.$nextTick(() => window.vm.$store.dispatch('checkLoggedInStateIfNeeded'))	
	}, 10)
})

export default router
